const jwtServiceConfig = {
  signIn: `${process.env.REACT_APP_API_SERVICE_URL}/api/auth/login`,
  logout: `${process.env.REACT_APP_API_SERVICE_URL}/api/auth/logout`,
  requestNewPassword: `${process.env.REACT_APP_API_SERVICE_URL}/api/auth/request_reset`,
  resetPassword: `${process.env.REACT_APP_API_SERVICE_URL}/api/auth/reset_password`,
  signUp: 'api/auth/sign-up',
  accessToken: `${process.env.REACT_APP_API_SERVICE_URL}/api/auth/status`,
  updateUser: 'api/auth/user/update'
};

export default jwtServiceConfig;
